export const TYPES = {
  DbManager: Symbol.for('DbManager'),
  PersistentRepository: Symbol.for('PersistentRepository'),
  AmplitudeManager: Symbol.for('AmplitudeManager'),
};
